<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br>
            {{ userStore.user.ssn }}
            <br>
            {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            RE: Intent to file suit- violation of the FCRA 
        </p>
        <p> Dear {{creditBureau.name}}, </p>
        <p class="letter-content">
            I am sure you are aware that it is against the law to threaten suit without any intention of doing 
            so. Therefore, be advised that I am extremely serious about filing suit against your company.
        </p>
        <p class="letter-content">
            I have sent numerous letters requesting for you to investigate and remove all inaccurate 
            information that is being reported on my personal credit profile, yet you continue to fail to do so.
        </p>
        <p class="letter-content">
            It is my understanding of the law that you MUST honor each and every request to investigate 
            incorrect information and you seem to have ignored all of my previous requests. That is a crystal 
            clear violation of the Fair Credit Reporting Act which provides a cause of action for an individual 
            consumer as well as penalties and liabilities for both consumer reporting agencies and furnishers 
            of information for non-compliance as violation of its provisions.
        </p>
        <p class="letter-content">
            As I stated before, this is my final request for you to do as you are governed by the FCRA. If this 
            final request does not prompt you to conduct a proper investigation of the accounts in question, I 
            will be forced to file suit against your company in the county in which I live. That way, you can 
            travel here in order to defend yourselves.
        </p>
        <p class="letter-content">
            Add This sentence and then list the accounts:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p class="letter-content">
            I take my credit very serious and your lack of professionalism and assistance disgusts me. I am 
            well aware of my rights under the FCRA and intend to pursue them to the maximum.
        </p>
        <p class="letter-content">
            Again I request that you to re-investigate the following accounts:
        </p>
        <p>
            Sincerely
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>

        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalDisputeDate: {
                type: String
            },
            dateAccountRemoved: {
                type: String
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                moment:moment,
                address,
            };
        },
    };
</script>
